/**
 * packaging-option.js
 * Global packaging selector — OPTIONAL field.
 *
 * Customer can skip selection — Add to Cart is never blocked.
 * If Ice Box is selected, it is added as a flat +25 AED line item (qty = 1).
 * If Standard Carton Box or nothing is selected, Ice Box is removed from cart.
 *
 * Standard Carton Box : Free
 * Ice Box             : +25 AED flat per order (qty always = 1)
 */

(function () {
  'use strict';

  var ICE_BOX_VARIANT_ID = 48565120762061;
  var STORAGE_KEY        = 'dabaye_packaging';
  var ICE_BOX_LABEL      = 'Ice Box';
  var STANDARD_LABEL     = 'Standard Carton Box';

  /* ------------------------------------------------------------------ */
  /* Helpers                                                              */
  /* ------------------------------------------------------------------ */

  function getChoice() {
    return sessionStorage.getItem(STORAGE_KEY) || null;
  }

  function saveChoice(val) {
    sessionStorage.setItem(STORAGE_KEY, val);
  }

  /* ------------------------------------------------------------------ */
  /* Dropdown init                                                        */
  /* ------------------------------------------------------------------ */

  function initDropdown() {
    var sel = document.getElementById('packaging-option-select');
    if (!sel) return;

    // Restore saved choice
    var saved = getChoice();
    if (saved) {
      var label = saved === 'icebox' ? ICE_BOX_LABEL : STANDARD_LABEL;
      sel.value = label;
      setHiddenInputs(label);
    } else {
      sel.value = '';
      setHiddenInputs('');
    }

    if (!sel.dataset.pkgBound) {
      sel.dataset.pkgBound = '1';
      sel.addEventListener('change', function () {
        var raw = this.value;
        if (!raw) {
          // User cleared selection
          saveChoice('');
          setHiddenInputs('');
          syncIceBoxInCart();
          return;
        }
        var key = raw === ICE_BOX_LABEL ? 'icebox' : 'standard';
        saveChoice(key);
        setHiddenInputs(raw);
        this.style.borderColor = 'var(--t4s-color-btn, #000)';
        syncIceBoxInCart();
      });
    }
  }

  function setHiddenInputs(value) {
    document.querySelectorAll('#packaging-hidden-input').forEach(function (el) {
      el.value = value;
    });
  }

  /* ------------------------------------------------------------------ */
  /* Ensure hidden input is populated on ATC (no blocking)               */
  /* ------------------------------------------------------------------ */

  function bindForms() {
    document.querySelectorAll('[data-type="add-to-cart-form"]').forEach(function (form) {
      if (form.dataset.pkgBound) return;
      form.dataset.pkgBound = '1';
      form.addEventListener('submit', function () {
        // Just sync the value — never block
        var choice = getChoice();
        if (choice) {
          setHiddenInputs(choice === 'icebox' ? ICE_BOX_LABEL : STANDARD_LABEL);
        }
      }, true);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Ice Box cart sync                                                    */
  /* ------------------------------------------------------------------ */

  function getCart() {
    return _origFetch('/cart.js').then(function (r) { return r.json(); });
  }

  function syncIceBoxInCart() {
    var choice  = getChoice();
    var wants   = (choice === 'icebox');

    getCart().then(function (cart) {
      var found = null;
      cart.items.forEach(function (item) {
        if (item.variant_id === ICE_BOX_VARIANT_ID) found = item;
      });

      if (wants && !found)                             addIceBox();
      else if (!wants && found)                        removeIceBox(found.key);
      else if (wants && found && found.quantity !== 1) setIceBoxQty(found.key, 1);
    });
  }

  function addIceBox() {
    _origFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: ICE_BOX_VARIANT_ID, quantity: 1 }] })
    }).then(refreshCart);
  }

  function removeIceBox(key) {
    _origFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(refreshCart);
  }

  function setIceBoxQty(key, qty) {
    _origFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(refreshCart);
  }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('t4s:cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh',     { bubbles: true }));
  }

  /* ------------------------------------------------------------------ */
  /* fetch wrapper — sync ice box after any ATC, no blocking            */
  /* ------------------------------------------------------------------ */

  var _origFetch = window.fetch;
  window.fetch = function (url, opts) {
    var p = _origFetch.apply(this, arguments);
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
      p.then(function () { setTimeout(syncIceBoxInCart, 800); });
    }
    return p;
  };

  /* ------------------------------------------------------------------ */
  /* Init                                                                 */
  /* ------------------------------------------------------------------ */

  function init() {
    initDropdown();
    bindForms();
    if (window.location.pathname === '/cart') syncIceBoxInCart();
  }

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('t4s:section:load', function () {
    initDropdown();
    bindForms();
  });

  document.addEventListener('t4s:cart:added', function () {
    setTimeout(syncIceBoxInCart, 600);
  });

})();
